<script>
  export let spacing, style
</script>

<div class="container spacing_{spacing}" style={style}>
  <slot></slot>
</div>